<template>
    <div class="modal fade" id="modalDownloadPoLabel" role="dialog">
        <div class="modal-dialog modal-lg" role="document" style="max-width: 900px;">
            <div class="modal-content">
                <div class="modal-header border-bottom">
                    <div>
                        <h5 class="modal-title font-weight-bold mb-1">Download Batch Number Label</h5>
                        <small class="text-muted">{{modalData.prId}}</small>
                    </div>
                    <button type="button" class="close" @click="closeModal">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <!-- Warning Alert -->
                    <div class="alert alert-warning d-flex align-items-center mb-4" role="alert">
                        <i class="fas fa-info-circle mr-2"></i>
                        <span>Hanya item dengan Batch Number yang dapat untuk diunduh di sini.</span>
                    </div>

                    <!-- Table -->
                    <div class="table-responsive">
                        <table class="table table-borderless">
                            <thead class="bg-light">
                                <tr>
                                    <th class="text-uppercase small font-weight-bold text-muted">No Item</th>
                                    <th class="text-uppercase small font-weight-bold text-muted">Nama Item</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in modalData.items" :key="item.id" class="border-bottom">
                                    <td class="align-middle">{{ item.itemCode }}</td>
                                    <td class="align-middle">{{ item.itemName }}</td>
                                    <td class="text-right align-middle">
                                        <button 
                                            v-if="item.hasBatchNumber"
                                            class="btn btn-primary btn-sm px-3"
                                            @click="downloadLabel(item.batchNumber)"
                                        >
                                            <i class="fas fa-download mr-1"></i> Download Label
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer border-top">
                    <button type="button"  class="btn btn-outline-secondary btn-custom text-dark" @click="closeModal">Kembali</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'ModalDownloadPoLabel',
  props: ['modalData'],
  data () {
    return {
      invoiceDetailLogData : [],
    }
  },
  methods:{
    closeModal() {
       $(`#modalDownloadPoLabel`).modal('hide')
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    forceFileDownload(response, filename) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    downloadLabel(batchNumber) {
      this.$http.post( process.env.DOWNLOAD_PR_LABEL,
        {
          data : [batchNumber],
          type : 'batch_number'
        },
        {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
          responseType: "arraybuffer",
        }
      )
      .then((res) => {
        const responseType = res.config.responseType
    
        let responseStatus = ''
        let responseMessage = ''
        if (responseType && responseType == 'arraybuffer') {
          const responseBufferJSON = Buffer.from(res.data).toJSON();
          if (responseBufferJSON.data[0] == 123) {
              let responseString = ''
              responseBufferJSON.data.forEach(item => {
                responseString = responseString + String.fromCharCode(item)
              })
              const response = JSON.parse(responseString)
              responseStatus = response.status
              responseMessage = response.message
          } else {
            this.forceFileDownload(res,"label_" + batchNumber + ".pdf");
            // this.loadingButtonDownload = false
          }
        }
        if(responseStatus == 400) {  
          swal("Sorry", responseMessage , "error", {
            button: "Close"
          });
          this.loadingButtonDownload = false
        }
      })
      .catch(error => {
        console.log(error)
        swal("Sorry", error.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.status == 401) {
            this.handleLogout()
          }
        })
      });
    },
  },
  created(){
    this.admin = localStorage.getItem('admin_name')
    // this.cekLogin()
    // this.cekPermission()
  }
}
$(document).ready(function(){
  var self = this
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-custom:hover {
  background-color: #f0f0f0;
  border-color: #ccc;
  color: #000000;
}
.modal {
  background-color: rgba(0, 0, 0, 0.5);
}

.modal.show {
  display: block;
}

.modal-backdrop.show {
  opacity: 0.5;
}

.alert-warning {
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  color: #856404;
  border-radius: 0.25rem;
}

.table td, .table th {
  padding: 1rem;
  vertical-align: middle;
}

.table thead th {
  border-bottom: 2px solid #dee2e6;
  font-size: 0.875rem;
  letter-spacing: 0.5px;
}

.table tbody tr:last-child {
  border-bottom: none !important;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

.modal-header {
  padding: 1.25rem 1.5rem;
}

.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  padding: 1rem 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Purchase/CustomComponent/ModalDownloadLabel.vue